var map = {
	"./Are Solar Panels Worth It in Melbourne.jpg": 5498,
	"./How Long Do Solar Batteries Last.jpg": 4560,
	"./How Long Do Solar Panels Last.jpg": 5446,
	"./How Many Solar Panels Do I Need.jpg": 5010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6901;